export default __webpack_public_path__ + "static/media/moonstoneLogo.2be6c9bf.svg";